import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/**
 * The one Product updates button on a platen variant issue. Shown only for the
 * `upload` route of `usePlatenVariantRoute` (an admin on their own org's issue).
 * Same tab, so `ArrowRight`, never the new-tab `ExternalLink` icon.
 */
export function PlatenVariantUpdatesLink({
  href,
  className,
  iconClassName = 'h-3.5 w-3.5',
  'data-testid': testId,
}: {
  href: string;
  className?: string;
  iconClassName?: string;
  'data-testid'?: string;
}) {
  const { t } = useTranslation('production');
  return (
    <Button
      asChild
      size="sm"
      className={cn('h-12 gap-1.5 bg-threadheads-purple text-white hover:bg-threadheads-purple/90', className)}
    >
      <Link to={href} data-testid={testId}>
        {t('issues.printFiles.platenVariant.openUpdates')}
        <ArrowRight className={iconClassName} aria-hidden="true" />
      </Link>
    </Button>
  );
}
